import { Profile, Organization } from "@/types/directory";
import { DirectoryResults } from "@/components/directory/DirectoryResults";
import { DirectoryPagination } from "./DirectoryPagination";
import { LoadingState } from "./LoadingState";
import { EmptyState } from "./EmptyState";

interface DirectoryContentProps {
  profiles: Profile[];
  organizations: Organization[];
  loading: boolean;
  showOrganizations: boolean;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const DirectoryContent = ({
  profiles,
  organizations,
  loading,
  showOrganizations,
  currentPage,
  totalPages,
  onPageChange,
}: DirectoryContentProps) => {
  if (loading) {
    return <LoadingState />;
  }

  const items = showOrganizations ? organizations : profiles;
  
  if (!items.length) {
    return <EmptyState showOrganizations={showOrganizations} />;
  }

  return (
    <div className="space-y-6">
      <DirectoryResults
        selectedDirectoryCategory={showOrganizations ? 'organizations' : 'people'}
        filteredProfiles={profiles}
        filteredOrganizations={organizations}
      />
      
      <DirectoryPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </div>
  );
};
